<template>
  <div>
    <Head :title="$t('volunteers.volunteers')"/>
    <h1 class="mb-8 text-3xl font-bold">{{ $t('volunteers.volunteers') }}</h1>
    <Table
      :resource="data"
      class="custom-table-layout rounded"
      url-to-view="volunteers"
      cookie-name="volunteers"
      :remember-table="true"
    >
      <template v-slot:extraButtons>
        <Link class="btn-indigo inline-flex items-center mr-2" href="/volunteers/create" style="height: 38px">
          <icon name="plus" class="w-4 h-4 fill-current text-white mr-2"/>
          <span class="capitalize">{{ $t('volunteers.new') }}</span>
        </Link>
      </template>
      <template #cell(stats_treatments)="{ item: data }">
        <progressbar :current="data.stats_treatments.total" :max="data.stats_treatments.max"/>
      </template>
      <template #cell(authorization_date)="{ item: data }">
        <badge :text="$filters.formatDate(data.authorization_date)" :color="$functions.getDateColor(data.authorization_date)"></badge>
      </template>
      <template #cell(languages)="{ item: volunteer }">
        {{ volunteer.languages.join(', ') }}
      </template>
      <template #cell(status)="{ item: volunteer }">
        <yes-no :value="!!volunteer.status"/>
      </template>
    </Table>
  </div>
</template>
<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Table from '@/Shared/Table/Components/Table'
import Progressbar from '@/Shared/Progressbar'
import Badge from '@/Shared/Badge'
import YesNo from "@/Shared/YesNo";

export default {
  components: {
    Head,
    Icon,
    Link,
    Table,
    Progressbar,
    Badge,
    YesNo
  },
  layout: Layout,
  props: {
    data: Object,
  },
}
</script>
